/**Dependencies */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaCcAmex,
  FaCcMastercard,
  FaCcPaypal,
  FaCcVisa,
  FaFacebook,
  FaInstagram,
  FaPhoneAlt,
  FaTiktok,
} from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
/**Components */
import { Row, Col, Image, Nav, NavLink, Navbar } from "react-bootstrap";

/**Images */
import logoBanner from "../images2/icons/Logo.png";
import bbva from "../images2/icons/bbva.svg";
/**Styles */
import "../styles/footer.scss";
import { RiVisaLine } from "react-icons/ri";
import { SiAmericanexpress } from "react-icons/si";

/**Componente para renderizar el footer*/
export const Footer = () => {
  const [showSecciones, setShowSecciones] = useState(true);
  const isMobile = window.innerWidth <= 430;

  return (
    <>
      <footer className="text-white border-top border-1 border-secondary">
        <div className="container bg-footer-secctions pt-5">
          <Row>
            <Col lg={4} md={12} sm={12} className="mt-5">
              <div className="d-flex justify-content-center p-4">
                <Navbar.Brand as={Link} to={"/"}>
                  <Image
                    src={logoBanner}
                    alt="company_logo"
                    rounded
                    className="img-logo-footer"
                  />
                </Navbar.Brand>
              </div>
              <Col lg={12}>
                <Row className="justify-content-center">
                  <Col xs={2} className="mt-3 text-center">
                    <FaCcVisa style={{ fontSize: "45px", color: "#47494A" }} />
                  </Col>
                  <Col xs={2} className="mt-3 text-center">
                    <FaCcAmex style={{ fontSize: "45px", color: "#47494A" }} />
                  </Col>
                  <Col xs={2} className="mt-3 text-center">
                    <FaCcMastercard
                      style={{ fontSize: "45px", color: "#47494A" }}
                    />
                  </Col>
                  <Col xs={2} className="mt-3 text-center">
                    <FaCcPaypal
                      style={{ fontSize: "45px", color: "#47494A" }}
                    />
                  </Col>
                  <Col xs={2} className="mt-3 text-start">
                    <img
                      src={bbva}
                      style={{ width: "45px", color: "#47494A" }}
                      alt=""
                    />
                  </Col>
                </Row>
              </Col>
            </Col>
            <Col lg={6} md={12} sm={12} className="mt-4 secciones-md-right">
              <h5 className="mx-3 fw-bolder" style={{ color: "#47494A" }}>
                Secciones
              </h5>

              {(!isMobile || showSecciones) && (
                <Row>
                  <Col>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="w-100 w-md-50">
                        <Nav className="flex-column fs-5">
                          {[
                            { to: "/", text: "Home" },
                            { to: "/hoteles", text: "Hoteles" },
                            { to: "/experiencias", text: "Experiencias" },
                            { to: "/circuitos", text: "Circuitos" },
                            { to: "/traslados", text: "Traslados" },
                            { to: "/renta-autos", text: "Renta de Autos" },
                          ].map((item, idx) => (
                            <NavLink
                              key={idx}
                              className="text-sm mb-2"
                              style={{ color: "#47494A" }}
                              as={Link}
                              to={item.to}
                              onClick={() =>
                                window.scroll({ top: 0, behavior: "smooth" })
                              }
                            >
                              {item.text}
                            </NavLink>
                          ))}
                        </Nav>
                      </div>
                      <div className="w-100 w-md-50">
                        <Nav className="flex-column fs-5">
                          {[
                            {
                              to: "/terminos-y-condiciones",
                              text: "Términos y Condiciones",
                            },
                            {
                              to: "/politica-de-cookies",
                              text: "Política de Cookies",
                            },
                            {
                              to: "/politica-de-privacidad",
                              text: "Políticas de Privacidad",
                            },
                            {
                              to: "/preguntas-frecuentes",
                              text: "Preguntas Frecuentes",
                            },
                            { to: "/nosotros", text: "Nosotros" },
                          ].map((item, idx) => (
                            <NavLink
                              key={idx}
                              className=" text-sm mb-2"
                              style={{ color: "#47494A" }}
                              as={Link}
                              to={item.to}
                              onClick={() =>
                                window.scroll({ top: 0, behavior: "smooth" })
                              }
                            >
                              {item.text}
                            </NavLink>
                          ))}
                        </Nav>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
            <Col lg={2} md={12} sm={12} className="mt-4 text-center">
              <h5 className="mt-0 mb-4 fw-bolder" style={{ color: "#47494A" }}>
                Síguenos en
              </h5>

              <div>
                <Row className="justify-content-center">
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className=""
                      style={{ color: "#47494A" }}
                      as={Link}
                      to="https://www.facebook.com/agenciamarzah/?locale=es_LA"
                    >
                      <FaFacebook
                        style={{ fontSize: "20px", color: "#47494A" }}
                      />
                    </NavLink>
                  </Col>
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className=""
                      style={{ color: "#47494A" }}
                      as={Link}
                      to="https://www.tiktok.com/@agenciamarzah?is_from_webapp=1"
                    >
                      <FaTiktok
                        style={{ fontSize: "20px", color: "#47494A" }}
                      />
                    </NavLink>
                  </Col>
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className=""
                      style={{ color: "#47494A" }}
                      as={Link}
                      to="https://www.instagram.com/agenciamarzah"
                    >
                      <FaInstagram
                        style={{ fontSize: "20px", color: "#47494A" }}
                      />
                    </NavLink>
                  </Col>
                  <Col xs="3" className="d-flex justify-content-center mb-2">
                    <NavLink
                      className=""
                      style={{ color: "#47494A" }}
                      as={Link}
                      to="mailto:ventas@agenciamarzah.com"
                    >
                      <IoMdMail
                        style={{ fontSize: "20px", color: "#47494A" }}
                      />
                    </NavLink>
                  </Col>
                </Row>
                <div className="mt-4 text-center">
                  <a
                    href="tel:+9982189740"
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#47494A",
                      textDecoration: "none",
                    }}
                  >
                    <FaPhoneAlt /> 998 218 9740
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div style={{ width: "100%" }}>
          <Col className="d-flex justify-content-center py-3">
            <span
              style={{ fontSize: "14px", color: "#47494A", fontWeight: "bold" }}
            >
              © 2025 Marzah. Todos los derechos reservados.
            </span>
          </Col>
        </div>
        {/* <div
          style={{
            width: "100%",
            backgroundImage: `url(${bannerFooter})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "20px",
          }}
        ></div> */}
      </footer>
    </>
  );
};
